const MuiFormControlLabel = {
  styleOverrides: {
    label: {
      fontWeight: 'normal',
    },
  },
};

export default MuiFormControlLabel;
